export const singularValues = [null, '0', '1', 0, 1];
